import "core-js/modules/es.array.is-array.js";
import "core-js/modules/es.symbol.js";
import "core-js/modules/es.symbol.description.js";
import "core-js/modules/es.symbol.iterator.js";
import "core-js/modules/es.array.from.js";
import "core-js/modules/es.array.slice.js";
import "core-js/modules/es.function.name.js";
var _effectorFileName = "/builds/gmini/front-common/src/classifier-editor/SelectDependencies/ModelsTree/ModelsTree.tsx";

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _iterableToArrayLimit(arr, i) { var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"]; if (_i == null) return; var _arr = []; var _n = true; var _d = false; var _s, _e; try { for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread(); }

function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _iterableToArray(iter) { if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter); }

function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) return _arrayLikeToArray(arr); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

import "regenerator-runtime/runtime.js";

function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { Promise.resolve(value).then(_next, _throw); } }

function _asyncToGenerator(fn) { return function () { var self = this, args = arguments; return new Promise(function (resolve, reject) { var gen = fn.apply(self, args); function _next(value) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value); } function _throw(err) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err); } _next(undefined); }); }; }

import "core-js/modules/es.array.filter.js";
import "core-js/modules/es.object.values.js";
import "core-js/modules/es.array.map.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.promise.js";
import "core-js/modules/es.promise.finally.js";
import "core-js/modules/es.array.iterator.js";
import "core-js/modules/es.string.iterator.js";
import "core-js/modules/web.dom-collections.iterator.js";
import "core-js/modules/es.array.some.js";
import "core-js/modules/es.array.concat.js";
import * as React from 'react';
import { combine, createEvent, restore, createEffect, forward } from 'effector';
import { useStore } from 'effector-react';
import { isNotEmpty } from '@gmini/utils';
import * as smApi from '@gmini/sm-api-sdk';
import { filterNotExistingActive, fromRefs, MacosExplorer } from '@gmini/ui-kit/lib/MacosExplorer';
import { Backdrop, ProgressBar } from "../BackDrop";
import { PANEL_WIDTH } from "./constants";
import { ItemRenderer } from "./ItemRender";
import { ItemPropsCtx } from "./itemPropsCtx";
import { currentModelsByClassifierId$, createTree } from "./createTree";
import { createSelectDepsStoreService } from "./node/node";
import { PanelRenderer } from "./PanelRenderer";
import { jsx as _jsx } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export function createModelsTree(_ref) {
  var addedDependencyIds$ = _ref.addedDependencyIds$,
      inclusionStatus$ = _ref.inclusionStatus$,
      currentModelsByClassifierMap$ = _ref.currentModelsByClassifierMap$,
      currentEntity$ = _ref.currentEntity$,
      notification = _ref.notification,
      seoEventHandler = _ref.seoEventHandler;
  forward({
    ɔ: {
      from: currentModelsByClassifierMap$,
      to: currentModelsByClassifierId$
    },
    config: {
      sid: "mpezg6"
    }
  });

  var _createSelectDepsStor = createSelectDepsStoreService(notification, currentEntity$),
      rootNodes$ = _createSelectDepsStor.rootNodes$,
      flatNodes$ = _createSelectDepsStor.flatNodes$,
      bimFile$ = _createSelectDepsStor.bimFile$;

  var tree$ = createTree({
    rootNodes$: rootNodes$,
    flatNodes$: flatNodes$
  });
  var setPreloadPending = createEvent({
    name: "setPreloadPending",
    sid: "-qwzsy0"
  });
  var resetPreloadPending = createEvent({
    name: "resetPreloadPending",
    sid: "z0n7df"
  });
  var preloadPending$ = restore(setPreloadPending, true, {
    name: "preloadPending$",
    sid: "ejxa2l"
  }).on(resetPreloadPending, function () {
    return true;
  });
  var loadNodes = createEffect({
    handler: function handler(_ref2) {
      var nodes = _ref2.nodes,
          projectUrn = _ref2.projectUrn;
      var opened = nodes;
      var items = Object.values(opened).filter(isNotEmpty);
      var promises = items.map( /*#__PURE__*/function () {
        var _ref3 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee(nRef) {
          return regeneratorRuntime.wrap(function _callee$(_context) {
            while (1) {
              switch (_context.prev = _context.next) {
                case 0:
                  if (!(nRef.type === 'ModelRepoFolderTreeNode')) {
                    _context.next = 3;
                    break;
                  }

                  _context.next = 3;
                  return smApi.NavigationModelRepoFolder.fetchFolderContent.defaultContext({
                    folderUrn: nRef.urn,
                    projectUrn: projectUrn
                  });

                case 3:
                case "end":
                  return _context.stop();
              }
            }
          }, _callee);
        }));

        return function (_x) {
          return _ref3.apply(this, arguments);
        };
      }());
      return Promise.all(_toConsumableArray(promises))["finally"](function () {
        return setPreloadPending(false);
      });
    }
  }, {
    name: "loadNodes",
    sid: "xwrkrt"
  });

  function initTree(_x2) {
    return _initTree.apply(this, arguments);
  }

  function _initTree() {
    _initTree = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee3(projectUrn) {
      var fromPersist, treeData, explorerTree, actual;
      return regeneratorRuntime.wrap(function _callee3$(_context3) {
        while (1) {
          switch (_context3.prev = _context3.next) {
            case 0:
              fromPersist = getFromPersist(buildLocalStorageOpenedKey(projectUrn));
              _context3.next = 3;
              return loadNodes({
                nodes: fromPersist,
                projectUrn: projectUrn
              });

            case 3:
              treeData = tree$.getState();
              explorerTree = fromTreeData(treeData);
              actual = filterNotExistingActive(explorerTree, fromNodeRefsToExplorerRefs(fromPersist));
              return _context3.abrupt("return", actual);

            case 7:
            case "end":
              return _context3.stop();
          }
        }
      }, _callee3);
    }));
    return _initTree.apply(this, arguments);
  }

  function getFromPersist(projectUrn) {
    try {
      var raw = localStorage.getItem(buildLocalStorageOpenedKey(projectUrn));
      return JSON.parse(raw || '[]');
    } catch (err) {
      return [];
    }
  }

  function saveToPersist(nodes, projectUrn) {
    localStorage.setItem(buildLocalStorageOpenedKey(projectUrn), JSON.stringify(nodes));
  }

  var manageDepsPending$ = combine({
    ɔ: [[smApi.UserClassifier.addDependency.defaultContext.pending$, smApi.UserClassifier.removeDependency.defaultContext.pending$]],
    config: {
      name: "manageDepsPending$",
      sid: "6r1ydc"
    }
  }).map(function (s) {
    return s.some(Boolean);
  });
  var ModelsTree = /*#__PURE__*/React.memo(function () {
    var treeData = useStore(tree$, {
      loc: {
        file: _effectorFileName,
        line: 152,
        column: 21
      },
      name: "ModelsTree",
      sid: "ModelsTree /src/classifier-editor/SelectDependencies/ModelsTree/ModelsTree.tsx [152, 21]"
    });
    var currentEntity = useStore(currentEntity$, {
      loc: {
        file: _effectorFileName,
        line: 153,
        column: 26
      },
      name: "ModelsTree",
      sid: "ModelsTree /src/classifier-editor/SelectDependencies/ModelsTree/ModelsTree.tsx [153, 26]"
    });
    var projectUrn = currentEntity === null || currentEntity === void 0 ? void 0 : currentEntity.projectUrn;
    var preloadPending = useStore(preloadPending$, {
      loc: {
        file: _effectorFileName,
        line: 156,
        column: 27
      },
      name: "ModelsTree",
      sid: "ModelsTree /src/classifier-editor/SelectDependencies/ModelsTree/ModelsTree.tsx [156, 27]"
    });
    var manageDepsPending = useStore(manageDepsPending$, {
      loc: {
        file: _effectorFileName,
        line: 157,
        column: 30
      },
      name: "ModelsTree",
      sid: "ModelsTree /src/classifier-editor/SelectDependencies/ModelsTree/ModelsTree.tsx [157, 30]"
    });
    React.useEffect(function () {
      if (!projectUrn) {
        return;
      }

      smApi.NavigationModelRepoFolder.fetchRootFolders.defaultContext({
        projectUrn: projectUrn
      });
      initTree(projectUrn).then(function (active) {
        return _setActiveItems(active);
      });
      return function () {
        return resetPreloadPending();
      };
    }, [projectUrn]);

    var _React$useState = React.useState([]),
        _React$useState2 = _slicedToArray(_React$useState, 2),
        activeItems = _React$useState2[0],
        _setActiveItems = _React$useState2[1];

    var data = React.useMemo(function () {
      return fromTreeData(treeData);
    }, [treeData]);
    var setActiveItems = React.useCallback(function (next) {
      if (!projectUrn) {
        return;
      }

      _setActiveItems(next);

      var toSaveData = fromRefs(data, next).map(function (_ref4) {
        var _ref4$payload = _ref4.payload,
            urn = _ref4$payload.urn,
            type = _ref4$payload.type;
        return {
          urn: urn,
          type: type
        };
      });
      saveToPersist(toSaveData, buildLocalStorageOpenedKey(projectUrn));
    }, [data, projectUrn]);
    var itemCtxValue = React.useMemo(function () {
      return {
        addedDependencyIds$: addedDependencyIds$,
        inclusionStatus$: inclusionStatus$,
        currentEntity$: currentEntity$,
        seoEventHandler: seoEventHandler
      };
    }, []);
    return /*#__PURE__*/_jsxs(_Fragment, {
      children: [/*#__PURE__*/_jsx(Backdrop, {
        open: preloadPending || manageDepsPending,
        children: /*#__PURE__*/_jsx(ProgressBar, {})
      }), !preloadPending &&
      /*#__PURE__*/
      // eslint-disable-next-line @typescript-eslint/no-explicit-any
      _jsx(ItemPropsCtx.Provider, {
        value: itemCtxValue,
        children: /*#__PURE__*/_jsx(MacosExplorer, {
          activeItems: activeItems,
          onChangeActive: setActiveItems,
          ItemRenderer: ItemRenderer,
          treeData: data,
          PanelRender: PanelRenderer,
          fetchChildren: /*#__PURE__*/function () {
            var _ref6 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2(_ref5) {
              var payload;
              return regeneratorRuntime.wrap(function _callee2$(_context2) {
                while (1) {
                  switch (_context2.prev = _context2.next) {
                    case 0:
                      payload = _ref5.payload;

                      if (currentEntity) {
                        _context2.next = 3;
                        break;
                      }

                      return _context2.abrupt("return");

                    case 3:
                      _context2.t0 = payload.type;
                      _context2.next = _context2.t0 === 'ModelRepoFolderTreeNode' ? 6 : 8;
                      break;

                    case 6:
                      _context2.next = 8;
                      return smApi.NavigationModelRepoFolder.fetchFolderContent.defaultContext({
                        folderUrn: payload.urn,
                        projectUrn: currentEntity.projectUrn
                      });

                    case 8:
                    case "end":
                      return _context2.stop();
                  }
                }
              }, _callee2);
            }));

            return function (_x3) {
              return _ref6.apply(this, arguments);
            };
          }(),
          panelWidth: PANEL_WIDTH
        })
      })]
    });
  });
  ModelsTree.displayName = 'ModelsTree';
  return {
    ModelsTree: ModelsTree,
    bimFile$: bimFile$
  };
}

function buildItemKey(_ref7) {
  var type = _ref7.type,
      urn = _ref7.urn;
  return "".concat(type, ":").concat(urn);
}

function fromTreeData(source) {
  return source.map(function (s) {
    return {
      key: buildItemKey(s),
      payload: s,
      skeletonTotal: 'hasChildren' in s ? 5 : 0,
      children: 'children' in s ? fromTreeData(s.children) : []
    };
  });
}

function fromNodeRefsToExplorerRefs(source) {
  return source.map(buildItemKey);
}

function buildLocalStorageOpenedKey(projectUrn) {
  var FOLDER_CLS_OPENED_KEY = 'FOLDER_CLS_OPENED_KEY';
  return "".concat(FOLDER_CLS_OPENED_KEY, "__").concat(projectUrn);
}